import React, { useState } from 'react';
import NeoCard from '../../../../../components/Common/NeoCard';
import NeoButton from '../../../../../components/Common/NeoButton';
import TaskService from '../../../../../services/task_service';

const formatTimeAgo = (timestamp) => {
    if (!timestamp) return '';
    try {
        const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
        return new Intl.DateTimeFormat('pt-BR', { 
            day: '2-digit', 
            month: 'short', 
            hour: '2-digit', 
            minute: '2-digit' 
        }).format(date);
    } catch {
        return '';
    }
};

const SidebarCardNotes = ({ item, idTenant, user, onRefresh }) => {
    const [newComment, setNewComment] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleAddComment = async () => {
        if (!newComment.trim() || !idTenant || !user) return;
        setIsSubmitting(true);
        try {
            await TaskService.addComment(idTenant, user, item.id, newComment);
            setNewComment('');
            if (onRefresh) onRefresh();
        } catch (error) {
            console.error("Erro ao adicionar comentario:", error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const comments = item?.comments || [];

    return (
        <div className="mb-4 pt-4 border-top">
            <h6 className="text-uppercase font-size-11 fw-bold text-brand-secondary mb-2">
                <i className="mdi mdi-note-text-outline me-1"></i>
                Anotações do Card
            </h6>

            {/* Lista de Comentários */}
            <div className="d-flex flex-column gap-3 mb-3">
                {comments.length === 0 ? (
                    <p className="text-muted fst-italic font-size-12 mb-0">
                        Nenhuma anotação vinculada a este card.
                    </p>
                ) : (
                    comments.map((comment, index) => (
                        <div key={comment.id || index} className="d-flex gap-2 p-2 rounded-3 border bg-white shadow-sm">
                            <div className="flex-shrink-0 mt-1" style={{ width: '28px', height: '28px' }}>
                                <div className="rounded-circle d-flex align-items-center justify-content-center bg-light border font-size-10 fw-bold text-brand-primary" style={{ width: '28px', height: '28px' }}>
                                    {(comment.createdBy?.name?.charAt(0) || 'U').toUpperCase()}
                                </div>
                            </div>
                            <div className="flex-grow-1">
                                <div className="d-flex justify-content-between align-items-start mb-1">
                                    <span className="fw-bold font-size-12 text-brand-primary">
                                        {comment.createdBy?.name || 'Usuário'}
                                    </span>
                                    <span className="text-muted font-size-10 fw-semibold">
                                        {formatTimeAgo(comment.createdAt)}
                                    </span>
                                </div>
                                <p className="mb-0 text-brand-secondary font-size-13" style={{ whiteSpace: 'pre-wrap' }}>
                                    {comment.text}
                                </p>
                            </div>
                        </div>
                    ))
                )}
            </div>

            {/* Novo Comentário */}
            <NeoCard thinBorder={true} bodyClassName="p-3" className="bg-light border-0 shadow-none">
                <div className="d-flex gap-3">
                    <div className="flex-shrink-0" style={{ width: '36px', height: '36px' }}>
                        <div className="rounded-circle d-flex align-items-center justify-content-center bg-white border shadow-sm fw-bold font-size-13 text-brand-primary" style={{ width: '36px', height: '36px' }}>
                            {(user?.displayName?.charAt(0) || user?.email?.charAt(0) || 'U').toUpperCase()}
                        </div>
                    </div>
                    <div className="flex-grow-1">
                        <textarea
                            className="form-control border-0 shadow-none bg-transparent p-0 font-size-13 text-brand-primary"
                            rows="3"
                            placeholder="Adicione uma anotação sobre esse card..."
                            value={newComment}
                            onChange={(e) => setNewComment(e.target.value)}
                            style={{ resize: 'none' }}
                        ></textarea>
                    </div>
                </div>
                <div className="d-flex justify-content-end pt-2 mt-2 border-top">
                    <NeoButton
                        variant="primary"
                        size="sm"
                        pill={true}
                        loading={isSubmitting}
                        disabled={!newComment.trim()}
                        onClick={handleAddComment}
                        iconRight="mdi-send-outline"
                    >
                        Registrar
                    </NeoButton>
                </div>
            </NeoCard>
        </div>
    );
};

export default SidebarCardNotes;
